import { CallStates } from "../../../../../SharedComponents/AppStates/Utils";

export const getSubjectTypes = (api, setCallState) => {
  return api
    .transact("GetEmailSubjectTypes", {})
    .then((response) => {
      setCallState(CallStates.SUCCESS);
      return response.apiResult;
    })
    .catch((e) => {
      return Promise.reject(e);
    });
};
